<template>
	<div class="mirror-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('mirror.text.title')" @back="goBack">
				<template slot="content">
					<span class="long-name" :title="gridData.elasticIp">
						{{gridData.elasticIp}}
					</span>						
					<div class="jc-list__header--right jc-box-action">
						<a :href="Config.MIRROR_HELP_URL" target="_blank">{{ $t('mirror.text.doc') }}</a>
						<!--操作-->
						<drop-down-operation :operations="availableOperatesArray"
							@clickSelectItem="selectOps"
							:buttonTitle="$t('privateNetwork.operate')">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" class="tabs">
				<!--资源信息-->
				<el-tab-pane :label="$t('detail.text.sourceInfo')">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form>
								<el-row :gutter="20">
									<el-col :span="8">
										<!--ID-->
										<el-form-item :label="$t('detail.text.id') | withColon">
											<p>
												<span>{{gridData.imageId | maybeEmpty}}</span>
												<copy-value :copyVal="gridData.imageId"></copy-value>
											</p>
										</el-form-item>
									</el-col>
									<!--镜像名称-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.mirrorName') | withColon"
											class="edit-jc-form">
										  	<span :title="gridData.imageName" class="instance-name">{{ gridData.imageName }}</span>
										  	<el-popover ref="editValue"
												trigger="click"
												:visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="300"
												v-if="showEditName"
												:value="showEditName">
												<edit-value :inputVal="gridData.imageName"
													v-if="showEditName"
													@sureEdit="editName"
													:inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
										  	</el-popover>
										  	<el-button 
										  		v-if="imageKind === 'private'"
										  		type="text" icon="jc-icon-edit"
												@click="showEditName = true"
												v-popover:editValue>
										  	</el-button>
										  	<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
								  	</el-col>
									<!--地域-->
									<el-col :span="8">
										<el-form-item :label="$t('create.text.region') | withColon">
											<p>{{regionName | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--镜像类型-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.mirrorType') | withColon">
											<p>{{gridData.imageKindName | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--体系架构-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.architecture') | withColon">
											<p>{{gridData.architecture | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--操作系统平台-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.osType') | withColon">
											<p>{{gridData.osType | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--操作系统版本-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.systemVersion') | withColon">
											<p>{{gridData.systemVersion | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--容量-->
									<el-col :span="8">
										<el-form-item :label="$t('retailInstance.text.capacity') | withColon">
											<p>{{gridData.size | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--创建时间-->
									<el-col :span="8">
										<el-form-item :label="$t('mirror.text.createTime') | withColon">
											<p>{{gridData.createTime | maybeEmpty}}</p>
										</el-form-item>
									</el-col>
									<!--描述-->
								  	<el-col :span="8">
										<el-form-item 
											:label="$t('privateNetInstance.description')| withColon"
											class="edit-jc-form">
										  	<span :title="gridData.imageRemark" class="instance-name">
												{{ gridData.imageRemark }}
										  	</span>
										  	<el-popover ref="editDes"
												trigger="click"
												:visible-arrow="false"
												:offset="0"
												placement="left-start"
												:width="300"
												v-if="showEditDes"
												:value="showEditDes">
												<edit-value :inputVal="gridData.imageRemark"
													v-if="showEditDes"
													@sureEdit="editDes"
													:type="'textarea'"
													:inputValRule="rules.description"
													:showEditDes.sync="showEditDes"
													:popTitle="$t('privateNetwork.editDescription')">
												</edit-value>
										  	</el-popover>
										  	<el-button type="text" icon="jc-icon-edit"
												@click="showEditDes = true"
												v-popover:editDes>
										  	</el-button>
										  	<div class="jc-colude-mask" v-if="showEditDes"></div>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<!--删除镜像-->
		<delete-mirror 
			:visible.sync="deleteMirrorDialogVisible"
			@refresh="goBack"
			:rowInfo="gridData"
			:pageSource="'detail'"
			:region="region">
		</delete-mirror>
	</div>
</template>

<script>
	import {
		MirrorOperationConstant,
		NetworkTypeConstant
	} from '@/common/Constants';
	import DeleteMirror from '@/components/common/DeleteMirror';
	import editValue from '@/components/privateNetwork/EditValue';
	import copyValue from '@/components/privateNetwork/CopyValue';
	import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
	import {queryImageInfoApi} from '@/api/mirror/detail/actions'

	export default {
		components: {
			dropDownOperation,
			editValue,
			copyValue,
			DeleteMirror
		},
		data() {
			const valName = (rule, value, callback) => {
				const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
				if (!reg.test(value)) {
					callback(new Error(this.$t('create.help.instanceNameRule')));
				} else {
					callback();
				}
			};
			const valDes = (rule, value, callback) => {
			  	if (value.length > 256) {
					callback(new Error(this.$t('detail.speechCraft.descriptionLongRule')));
			  	} else {
					callback();
			  	}
			};
			return {
				rules: {
					name: [
					  	{
							required: true,
							message: this.$t('privateNetwork.nameNotNull'),
					  	},
					  	{
							validator: valName,
					  	}
					],
					description: [
					  	{
							validator: valDes,
					  	}
					]
				},
				imageId: '',
				imageKind: '',
				// 支持的操作
				operatesArr: [
					'CREATE',
					'DELETE', // 删除
				],
				// 当前Mirror支持的操作
				availableOperatesArray: [],
				gridData: {},
				region: '',
				regionName: '',
				regions: {},
				showEditDes: false,
				showEditName: false,
				// 删除mirror弹框
				deleteMirrorDialogVisible: false,
			};
		},
		computed: {
		},
		mounted() {
			this.imageId = this.$route.query.imageId;
			this.region = this.$route.query.region;
			this.imageKind = this.$route.query.imageKind;
			this.regionName = this.$route.query.regionName;
			this.getImageInfo();
			this.getRegions();
		},
		watch: {},
		methods: {
			/**
        		* 获得region和regionName对照
	    	*/
		    getRegions() {
		        const params = {
		            networkType: NetworkTypeConstant.VPC
		        };
		        Ajax.get('api/cps/getRegions', params).then((res) => {
		            if (res.data) {
		                res.data.regions.forEach((region) => {
		                    this.regions[region.region] = region.regionName;
		                });
		            }
		        });
		    },
			getImageInfo() {
				let params = {
					imageId: this.imageId,
					imageKind: this.imageKind,
					region: this.region
				};
				queryImageInfoApi(params).then(res => {
					this.gridData = res.data;
					this.initOperates();
				}).catch(err => {

				});
			},
			// 操作下拉选初始化，删除
			initOperates() {
				this.availableOperatesArray = this.operatesArr.map((key) => {
					const {name} = this.$t(`mirror.operations.${key.toString().toLowerCase()}`);
					const item = {
						value: MirrorOperationConstant[key],
						operateName:name,
						ifShow: true,
						disabled: false
					};

					if (key === 'DELETE' && (this.gridData.instanceCount >= 1 || this.gridData.status === 'making')) {
						item.disabled = true;
						item.tip = this.$t('mirror.tips.createdInstanceDeleteNotAllowed');
					}
					return item;
				});
			},

			selectOps(item) {
				switch (item) {
					case MirrorOperationConstant.DELETE: {
						if(item.disabled){
							return false;
						}
						this.deleteMirrorDialogVisible = true;
						break;
					}
					case MirrorOperationConstant.CREATE: {
						this.$router.push({
				        	path: '/instance/vpc/create',
				        	query: { region: this.region }
					    });
						break;
					}
				}
			},
			goBack() {
				this.$router.push({
					path: '/image/list'
				});
			},

			// 编辑描述
			editDes(value) {
				const params = {
					region: this.region,
					imageId: this.imageId,
					imageRemark: value
				};
			  	Ajax.post('/api/cps/modifyImageRemark', params, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then((res) => {
					if (res.data.success) {
						this.gridData.imageRemark = value;
					}
				})
				.finally(() => {
				});
			},

			// 编辑名称
			editName(value) {
				const params = {
					region: this.region,
					imageId: this.imageId,
					imageName: value
				};
			  	Ajax.post('/api/cps/modifyImageName', params, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then((res) => {
					if (res.data.success) {
						this.gridData.imageName = value;
					}
				}).finally(() => {
					this.renew = true;
				});
			},
		}
	};
</script>

<style lang="scss">
	@import '~@/assets/scss/detailCommon.scss';
	@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/mirror/detail/Detail.vue